// removed by extract-text-webpack-plugin
module.exports = {"contentWrap":"ConsentTypeWinnipeg__contentWrap__3fe6i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeWinnipeg/ConsentTypeWinnipeg.css
// module id = 1346
// module chunks = 0